import {
  Button,
  Center,
  CircularProgress,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { FuncButton } from "../../customComponents/components/FuncButton";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { column } from "../helpers";
import {
  useVehicleTypeDelete,
  useVehicleTypeList,
  useVehicleTypeSet,
} from "../hooks";

export const VehicleTypeListScreen = () => {
  const [activeTypeId, setActiveTypeId] = useState(null);
  const toast = useToast();
  const labelRef = useRef<HTMLInputElement>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { vehicleTypeListLoading, vehicleTypeList, getVehicleTypeList } =
    useVehicleTypeList();
  const { vehicleTypeSetLoading, getVehicleTypeSet } = useVehicleTypeSet();
  const { vehicleTypeDeleteReq, vehicleTypeDeleteLoading } =
    useVehicleTypeDelete();

  useEffect(() => {
    getVehicleTypeList();
  }, []);

  const loading =
    vehicleTypeListLoading || vehicleTypeSetLoading || vehicleTypeDeleteLoading;

  const onClose = () => setModalIsOpen(false);

  const onSubmit = async () => {
    const label = labelRef?.current?.value;
    if (label) {
      const res = await getVehicleTypeSet({ id: activeTypeId, label });
      if (res.data.success) {
        toast({
          title: "Тип создана",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      }
      getVehicleTypeList();
      setModalIsOpen(false);
    }
  };

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Типы автомобилей</Heading>}
        onClick={() => {
          setActiveTypeId(null);
          setModalIsOpen(true);
        }}
        linkLabel="Добавить тип"
      >
        {loading ? (
          <Center>
            <CircularProgress isIndeterminate />
          </Center>
        ) : (
          <TableHead column={column}>
            {vehicleTypeList.map(({ id, label }) => (
              <Tr key={id}>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {id}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {label}
                  </Text>
                </Td>
                <Td isNumeric>
                  <FuncButton
                    onClick={() => {
                      setActiveTypeId(id);
                      setModalIsOpen(true);
                      setTimeout(() => {
                        labelRef.current.value = label;
                      }, 500);
                    }}
                  >
                    РЕДАКТИРОВАТЬ
                  </FuncButton>
                </Td>
                <Td isNumeric>
                  <Button
                    marginLeft={"20px"}
                    colorScheme="red"
                    onClick={() => {
                      if (window.confirm("Пожалуйста, подтвердите удаление")) {
                        vehicleTypeDeleteReq({ id }).then(() => {
                          getVehicleTypeList();
                        });
                      }
                    }}
                  >
                    Удалить
                  </Button>
                </Td>
              </Tr>
            ))}
          </TableHead>
        )}
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Добавить тип</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <FormControl>
                <FormLabel>Наименование</FormLabel>
                <Input ref={labelRef} placeholder="Наименование" />
              </FormControl>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button
              disabled={loading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              {activeTypeId ? "Редактировать" : "Создать"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
